import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassesAcccess extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassesAcccess'
  // Define default properties here
  static instanceDefaults () {
    return {
      email: '',
      accessType: 'read',
      compassId: null,
      userId: null,
    }
  }
}
const servicePath = 'compasses-access'
const servicePlugin = makeServicePlugin({
  Model: CompassesAcccess,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
